const impuestos = [
    {
        id: 1,
        nombre: "IMPUESTO_ISV_15"
    },
    {
        id: 2,
        nombre: "IMPUESTO_ISV_18"
    },

    {
        id: 3,
        nombre: "IMPUESTO_EXTENTO"
    }
];

module.exports = { impuestos }